import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { toMobile, __UNSAFE_FONT_TO_DIMSUM } from '@elliemae/ds-system';

var LabelElementNode = /*#__PURE__*/styled.div.withConfig({
  componentId: "nu03bl-0"
})(["overflow:hidden;display:flex;align-items:center;font-size:", ";font-weight:400;"], function (props) {
  return toMobile(props.theme.fontSizes[__UNSAFE_FONT_TO_DIMSUM(700)]);
});

function LabelElement(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(LabelElementNode, null, children);
}

LabelElement.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired
};

export default LabelElement;
//# sourceMappingURL=LabelElement.js.map
